
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/members-market/[slug]",
      function () {
        return require("private-next-pages/members-market/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/members-market/[slug]"])
      });
    }
  